import React, { useState } from "react";

const StopwordManager = ({stopwords, setStopwords}) => {
  const [input, setInput] = useState(""); // 입력창 상태

  // 불용어 추가 핸들러
  const handleKeyPress = (event) => {
    if (event.key === "Enter" && input.trim() !== "") {
      const normalizedInput = input.trim(); // 입력값의 앞뒤 공백 제거
      // 새로운 불용어 추가 (중복 방지)
      if (!stopwords.includes(normalizedInput)) {
        setStopwords((prevStopwords) => [normalizedInput, ...prevStopwords]);
      }
      setInput(""); // 입력창 초기화
    }
  };

  // 불용어 삭제 핸들러
  const handleDelete = (wordToDelete) => {
    setStopwords((prevStopwords) =>
      prevStopwords.filter((word) => word !== wordToDelete)
    );
  };

  return (
    <div>
      <p className="text-xl font-semibold">제거할 단어 등록</p>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          height: "400px",
          border: "1px solid #ddd",
          padding: "10px",
          overflowY: "auto",
        }}
      >
        {/* 불용어 리스트 */}
        <div style={{ flexGrow: 1, marginBottom: "10px", width: "100%" }}>
          {stopwords.length === 0 ? (
            <p style={{ fontStyle: "italic", textAlign: "center" }}>
              제거할 단어 리스트가 표시됩니다.
            </p>
          ) : (
            stopwords.map((word, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#f1f1f1",
                  marginBottom: "5px",
                  padding: "8px",
                  borderRadius: "5px",
                  width: "100%", // 부모 컨테이너 기준으로 100% 너비
                  boxSizing: "border-box", // 패딩 포함 너비 계산
                }}
              >
                <span
                  style={{
                    wordBreak: "break-all", // 긴 단어 줄바꿈 처리
                    flexGrow: 1, // 단어가 가능한 공간을 모두 차지하도록 설정
                  }}
                >
                  {word}
                </span>
                <button
                  onClick={() => handleDelete(word)}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "red",
                    fontWeight: "bold",
                    cursor: "pointer",
                    marginLeft: "10px", // 버튼과 단어 사이 간격
                  }}
                >
                  ✕
                </button>
              </div>
            ))
          )}
        </div>

        {/* 입력창 */}
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyUp={handleKeyPress} // onKeyDown 대신 onKeyUp 사용
          placeholder="시각화에서 제외할 단어 입력 후 Enter 눌러주세요"
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
          }}
        />
      </div>
    </div>
  );
};

export default StopwordManager;
